import { useEffect, useState } from 'react';

export function useApiUrl() {
    let initialUrl = typeof document !== 'undefined' && window.appConfig && window.appConfig.apiUrl
        ? window.appConfig.apiUrl
        : '';
    let [apiUrl, setApiUrl] = useState(initialUrl);
    useEffect(() => {
        if (typeof document !== 'undefined' && window.appConfig && window.appConfig.apiUrl !== apiUrl) {
            setApiUrl(window.appConfig.apiUrl);
        }
    }, [apiUrl]);
    return apiUrl;
}
